<div class="container">
  <div class="card-dados-perfil">
        <form #form="ngForm" class="form-perfil">
          <app-alert [dense]="true" [hideIcon]="true" [type]="'brand'" [title]="'Dados Pessoais'">
          </app-alert>
          <mat-form-field (blur)="removeFocus('inputNome')" class="fullwidth name-field" [class.error-margin]="inputNome.touched && inputNome?.errors"  appearance="outline">
            <mat-label>Nome</mat-label>
            <input
              id="inputNome"
              name="inputNome"
              type="text"
              #inputNome="ngModel"
              [(ngModel)]="clientePerfil.nome"
              matInput
              maxlength="250"
              (focus)="setFocus('inputNome')"
              (blur)="removeFocus('inputNome')"
              required>
                <button
                  *ngIf="(hasFocus('inputNome') || hasFocus('cancel-button-input-nome')) && inputNome.control.value?.length > 0" 
                  mat-icon-button 
                  matSuffix
                  class="cancel-icon "
                  type="button"
                  (mouseover)="setFocus('cancel-button-input-nome')"
                  (mouseleave)="removeFocus('cancel-button-input-nome')"
                  (click)="clearField(inputNome.control,'cancel-button-input-nome')">
                  <mat-icon >cancel</mat-icon>
              </button>
              <mat-error *ngIf="inputNome.touched && inputNome?.errors">
                <mat-icon class="material-symbols-outlined mat-icon-error">error</mat-icon>
                Este campo é obrigatório!
              </mat-error>
          </mat-form-field>
  
          <ng-container *ngIf="temColaboradorAutenticado">
            <mat-form-field class="fullwidth" [class.error-margin]="inputEmail.touched && inputEmail?.errors"  appearance="outline">
              <mat-label>Email</mat-label>
              <input
                matInput
                name="inputEmail"
                #inputEmail="ngModel"
                [(ngModel)]="clientePerfil.email"
                placeholder="exemplo@exemplo.com"
                autocomplete="off"
                type="email"
                required
                maxlength="100"
                pattern="^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$"
                (focus)="setFocus('inputEmail')"
                (blur)="removeFocus('inputEmail')"
                required>
                  <button
                    *ngIf="(hasFocus('inputEmail') || hasFocus('cancel-inputEmail')) && inputEmail.control.value?.length > 0" 
                    mat-icon-button 
                    matSuffix
                    class="cancel-icon "
                    type="button"
                    (mouseover)="setFocus('cancel-inputEmail')"
                    (mouseleave)="removeFocus('cancel-inputEmail')"
                    (click)="clearField(inputEmail.control,'cancel-inputEmail')">
                    <mat-icon >cancel</mat-icon>
                </button>
                <mat-error *ngIf="inputEmail.touched && inputEmail?.errors?.pattern">
                  <mat-icon class="material-symbols-outlined mat-icon-error">error</mat-icon>
                  Email inválido
                </mat-error>
                <mat-error *ngIf="inputEmail.touched && inputEmail?.errors?.required">
                  <mat-icon class="material-symbols-outlined mat-icon-error">error</mat-icon>
                  Este campo é obrigatório!
                </mat-error>
            </mat-form-field>
          
            <mat-form-field class="fullwidth" appearance="outline" [class.error-margin]="inputTelefoneCelular.touched && inputTelefoneCelular?.errors" >
              <mat-label>Telefone Celular</mat-label>
              <input
                id="inputTelefoneCelular"
                name="inputTelefoneCelular"
                type="tel"
                #inputTelefoneCelular="ngModel"
                [(ngModel)]="clientePerfil.celular"
                matInput
                required
                [modelSemMascara]="true"
                mascara="(00) 00000-0000"
                placeholder="(00) 00000-0000"
                (focus)="setFocus('inputTelefoneCelular')"
                (blur)="removeFocus('inputTelefoneCelular')"
                required>
                  <button
                    *ngIf="(hasFocus('inputTelefoneCelular') || hasFocus('cancel-inputTelefoneCelular')) && inputTelefoneCelular.control.value?.length > 0" 
                    mat-icon-button 
                    matSuffix
                    class="cancel-icon "
                    type="button"
                    (mouseover)="setFocus('cancel-inputTelefoneCelular')"
                    (mouseleave)="removeFocus('cancel-inputTelefoneCelular')"
                    (click)="clearField(inputTelefoneCelular.control,'cancel-inputTelefoneCelular')">
                    <mat-icon >cancel</mat-icon>
                </button>
                <mat-error *ngIf="inputTelefoneCelular.touched && inputTelefoneCelular?.errors">
                  <mat-icon class="material-symbols-outlined mat-icon-error">error</mat-icon>
                  Este campo é obrigatório!
                </mat-error>
            </mat-form-field>
          </ng-container>
   
          <mat-form-field class="fullwidth" appearance="outline">
            <mat-label>Telefone residencial</mat-label>
            <input
              id="inputTelefoneResidencial"
              name="inputTelefoneResidencial"
              type="tel"
              #inputTelefoneResidencial="ngModel"
              [(ngModel)]="clientePerfil.telefone"
              matInput
              [modelSemMascara]="true"
              mascara="(00) 0000-0000"
              placeholder="(00) 00000-0000" 
              placeholder="Telefone Residencial"
              (focus)="setFocus('inputTelefoneResidencial')"
              (blur)="removeFocus('inputTelefoneResidencial')">
                <button
                  *ngIf="(hasFocus('inputTelefoneResidencial') || hasFocus('cancel-button-input-inputTelefoneResidencial')) && inputTelefoneResidencial.control.value?.length > 0" 
                  mat-icon-button 
                  matSuffix
                  class="cancel-icon "
                  type="button"
                  (mouseover)="setFocus('cancel-button-input-inputTelefoneResidencial')"
                  (mouseleave)="removeFocus('cancel-button-input-inputTelefoneResidencial')"
                  (click)="clearField(inputTelefoneResidencial.control,'cancel-button-input-inputTelefoneResidencial')">
                  <mat-icon >cancel</mat-icon>
              </button>
              </mat-form-field>
  
          <app-alert [dense]="true" [hideIcon]="true" [type]="'brand'" class="address-alert" [title]="'Endereço'">
          </app-alert>
  
          <mat-form-field class="w-100"  [class.error-margin]="inputCep.touched && inputCep?.errors"  appearance="outline">
            <mat-label>CEP</mat-label>
            <input
              id="inputCep"
              name="inputCep"
              type="text"
              inputmode="numeric"
              required
              [modelSemMascara]="true"
              mascara="00000-000"
              #inputCep="ngModel"
              (input)="buscarEndereco($event)"
              [(ngModel)]="clientePerfil.endereco.cep"
              matInput
              placeholder="CEP"
              (focus)="setFocus('inputCep')"
              (blur)="removeFocus('inputCep')">
                <button
                  *ngIf="(hasFocus('inputCep') || hasFocus('cancel-button-input-inputCep')) && inputCep.control.value?.length > 0" 
                  mat-icon-button 
                  matSuffix
                  class="cancel-icon "
                  type="button"
                  (mouseover)="setFocus('cancel-button-input-inputCep')"
                  (mouseleave)="removeFocus('cancel-button-input-inputCep')"
                  (click)="clearField(inputCep.control,'cancel-button-input-inputCep')">
                  <mat-icon >cancel</mat-icon>
              </button>
              <mat-error *ngIf="inputCep.touched && inputCep?.hasError('required')">
                <mat-icon class="material-symbols-outlined mat-icon-error">error</mat-icon>
                Este campo é obrigatório!
              </mat-error>
              <mat-error *ngIf="inputCep.getError('cepNotFound')">
                <mat-icon class="material-symbols-outlined mat-icon-error">error</mat-icon>
                Informe um número de CEP válido.
              </mat-error>
          </mat-form-field>

          <mat-form-field class="fullwidth" [class.error-margin]="inputEndereco.touched && inputEndereco?.errors" appearance="outline">
            <mat-label>Endereço</mat-label>
            <input
              id="inputEndereco"
              name="inputEndereco"
              type="text"
              required
              [disabled]="disabledEndereco"
              maxlength="300"
              (blur)="clientePerfil.endereco.endereco = clientePerfil?.endereco.endereco.trim()"
              #inputEndereco="ngModel"
              [(ngModel)]="clientePerfil?.endereco.endereco"
              matInput
              placeholder="Endereço"
              (focus)="setFocus('inputEndereco')"
              (blur)="removeFocus('inputEndereco')">
                <button
                  *ngIf="(hasFocus('inputEndereco') || hasFocus('cancel-button-input-inputEndereco')) && inputEndereco.control.value?.length > 0" 
                  mat-icon-button 
                  matSuffix
                  class="cancel-icon "
                  type="button"
                  (mouseover)="setFocus('cancel-button-input-inputEndereco')"
                  (mouseleave)="removeFocus('cancel-button-input-inputEndereco')"
                  (click)="clearField(inputEndereco.control,'cancel-button-input-inputEndereco')">
                  <mat-icon >cancel</mat-icon>
              </button>
              <mat-error *ngIf="inputEndereco.touched && inputEndereco?.errors">
                <mat-icon class="material-symbols-outlined mat-icon-error">error</mat-icon>
                Este campo é obrigatório!
              </mat-error>
          </mat-form-field>
          
          <div class="multiple-field-container">
            <mat-form-field class="w-50" [class.error-margin]="inputNumero.touched && inputNumero?.errors" appearance="outline">
              <mat-label>Número</mat-label>
              <input
                id="inputNumero"
                name="inputNumero"
                mascara="99999999"
                required
                type="text"
                inputmode="numeric"
                #inputNumero="ngModel"
                [(ngModel)]="clientePerfil?.endereco.numero"
                matInput
                placeholder="Número"
                (focus)="setFocus('inputNumero')"
                (blur)="removeFocus('inputNumero')">
                  <button
                    *ngIf="(hasFocus('inputNumero') || hasFocus('cancel-button-input-inputNumero')) && inputNumero.control.value?.length > 0" 
                    mat-icon-button 
                    matSuffix
                    class="cancel-icon "
                    type="button"
                    (mouseover)="setFocus('cancel-button-input-inputNumero')"
                    (mouseleave)="removeFocus('cancel-button-input-inputNumero')"
                    (click)="clearField(inputNumero.control,'cancel-button-input-inputNumero')">
                    <mat-icon >cancel</mat-icon>
                </button>
                <mat-error *ngIf="inputNumero.touched && inputNumero?.errors">
                  <mat-icon class="material-symbols-outlined mat-icon-error">error</mat-icon>
                  Este campo é obrigatório!
                </mat-error>
            </mat-form-field>
                
            <mat-form-field class="w-50 " appearance="outline">
              <mat-label>Complemento</mat-label>
              <input
                id="inputComplemento"
                name="inputComplemento"
                type="text"
                maxlength="50"
                #inputComplemento="ngModel"
                [(ngModel)]="clientePerfil?.endereco.complemento"
                matInput
                placeholder="Complemento"
                (focus)="setFocus('inputComplemento')"
                (blur)="removeFocus('inputComplemento')">
                  <button
                    *ngIf="(hasFocus('inputComplemento') || hasFocus('cancel-inputComplemento')) && inputComplemento.control.value?.length > 0" 
                    mat-icon-button 
                    matSuffix
                    class="cancel-icon "
                    type="button"
                    (mouseover)="setFocus('cancel-inputComplemento')"
                    (mouseleave)="removeFocus('cancel-inputComplemento')"
                    (click)="clearField(inputComplemento.control,'cancel-inputComplemento')">
                    <mat-icon >cancel</mat-icon>
                </button>
            </mat-form-field>
          </div>
                  
          <mat-form-field class="fullwidth"  [class.error-margin]="inputBairro.touched && inputBairro?.errors" appearance="outline">
            <mat-label>Bairro</mat-label>
            <input
              required
              id="inputBairro"
              name="inputBairro"
              type="text"
              [disabled]="disabledBairro"
              #inputBairro="ngModel"
              maxlength="100"
              (blur)="clientePerfil.endereco.bairro = clientePerfil.endereco.bairro.trim()"
              [(ngModel)]="clientePerfil?.endereco.bairro"
              matInput
              placeholder="Bairro"
              (focus)="setFocus('inputBairro')"
              (blur)="removeFocus('inputBairro')">
                <button
                  *ngIf="(hasFocus('inputBairro') || hasFocus('cancel-inputBairro')) && inputBairro.control.value?.length > 0" 
                  mat-icon-button 
                  matSuffix
                  class="cancel-icon "
                  type="button"
                  (mouseover)="setFocus('cancel-inputBairro')"
                  (mouseleave)="removeFocus('cancel-inputBairro')"
                  (click)="clearField(inputBairro.control,'cancel-inputBairro')">
                  <mat-icon >cancel</mat-icon>
              </button>
              <mat-error *ngIf="inputBairro.touched && inputBairro?.errors">
                <mat-icon class="material-symbols-outlined mat-icon-error">error</mat-icon>
                Este campo é obrigatório!
              </mat-error>
          </mat-form-field>
  
          <div class="multiple-field-container">
            <mat-form-field class="w-95" [class.error-margin]="inputCidade.touched && inputCidade?.errors" appearance="outline">
              <mat-label>Cidade</mat-label>
              <input
                id="inputCidade"
                name="inputCidade"
                type="text"
                #inputCidade="ngModel"
                required
                [disabled]="disabledCidade"
                maxlength="200"
                (blur)="clientePerfil.endereco.cidade = clientePerfil.endereco.cidade.trim()"
                [(ngModel)]="clientePerfil?.endereco.cidade"
                matInput
                placeholder="Cidade"
                (focus)="setFocus('inputCidade')"
                (blur)="removeFocus('inputCidade')">
                  <button
                    *ngIf="(hasFocus('inputCidade') || hasFocus('cancel-inputCidade')) && inputCidade.control.value?.length > 0" 
                    mat-icon-button 
                    matSuffix
                    class="cancel-icon "
                    type="button"
                    (mouseover)="setFocus('cancel-inputCidade')"
                    (mouseleave)="removeFocus('cancel-inputCidade')"
                    (click)="clearField(inputCidade.control,'cancel-inputCidade')">
                    <mat-icon >cancel</mat-icon>
                </button>
                <mat-error *ngIf="inputCidade.touched && inputCidade?.errors">
                  <mat-icon class="material-symbols-outlined mat-icon-error">error</mat-icon>
                  Este campo é obrigatório!
                </mat-error>
            </mat-form-field>
  
            <mat-form-field class="w-15" [class.error-margin]="inputUf.touched && inputUf?.errors" appearance="outline">
              <mat-label>{{(isMobile | async).matches ? 'Estado' : 'UF' }}</mat-label>
              <mat-select 
                required
                id="inputUf"
                name="inputUf"
                [disabled]="disabledUf"
                #inputUf="ngModel"
                [(ngModel)]="clientePerfil?.endereco.uf">
                <ng-container *ngIf="(isMobile | async).matches">
                  <mat-option
                    *ngFor="let uf of listaUf"
                    [value]="uf.sigla">
                    {{ uf.nome }}
                  </mat-option>
                </ng-container>
                <ng-container *ngIf="!(isMobile | async).matches">
                  <mat-option
                    *ngFor="let uf of listaUf"
                    [value]="uf.sigla">
                    {{ uf.sigla }}
                  </mat-option>
                </ng-container>
              </mat-select>
               <mat-error *ngIf="inputUf.touched && inputUf?.errors">
                <mat-icon class="material-symbols-outlined mat-icon-error">error</mat-icon>
                Este campo é obrigatório!
              </mat-error>
            </mat-form-field>
          </div>
  
          <div class="action">
            <button 
              type="button"
              mat-button
              class="outlined"
              mat-stroked-button 
              color="primary"
              [disabled]="!form.dirty"
              (click)="voltarAoInicio()">
              Cancelar
            </button>
            <button 
              type="button"
              (click)="salvarDadosBasicos()"
              mat-flat-button
              [disabled]="!form.dirty || (form.touched && form.invalid)"
              color="primary">
              Salvar
            </button>
          </div>
        </form>
  </div>
  
  <div class="dados-seguranca" *ngIf="!temColaboradorAutenticado">
    <app-alert [dense]="true" [hideIcon]="true" [type]="'brand'" class="seguranca-alert" [title]="'Informações de segurança'">
    </app-alert>
  
    <div class="warning-alert cadastro-alert">
      <mat-icon class="material-symbols-outlined">{{securityAlertText.icon}}</mat-icon>
      
      <span>
        <strong>{{securityAlertText.title}}</strong>
        {{securityAlertText.text }}
      </span>
    </div>
  
    <div class="card-dados-perfil">
      <div class="card-dados-perfil-content">
        <mat-form-field class="w-100 disabled-view" appearance="outline">
          <mat-label>Senha</mat-label>
          <input
            type="text"
            [disabled]="true"
            matInput
            value="********"
            placeholder="Senha">
        </mat-form-field>
        <div class="action">
          <button  mat-flat-button class="text-button"
          color="primary" (click)="goToSelectValidationTypePage(TipoAlteracaoPerfilEnum.SENHA)" color="primary">
            Alterar senha
          </button>
          <button mat-flat-button color="primary" class="icon-button" (click)="goToSelectValidationTypePage(TipoAlteracaoPerfilEnum.SENHA)" color="primary">
            <mat-icon>edit</mat-icon>
          </button>
        </div>
      </div>
    </div>

    <div *ngIf="clientePerfil.email" class="card-dados-perfil">
      <div class="card-dados-perfil-content">
        <mat-form-field class="w-100  disabled-view" appearance="outline">
          <mat-label>E-mail</mat-label>
          <input
            type="text"
            [disabled]="true"
            matInput
            [value]="clientePerfil.email"
            placeholder="E-mail">
        </mat-form-field>
        <div class="action">
          <button  mat-flat-button class="text-button"
          color="primary" (click)="goToSelectValidationTypePage(TipoAlteracaoPerfilEnum.EMAIL)" color="primary">
            Alterar e-mail
          </button>
          <button mat-flat-button color="primary" class="icon-button" (click)="goToSelectValidationTypePage(TipoAlteracaoPerfilEnum.EMAIL)" color="primary">
            <mat-icon>edit</mat-icon>
          </button>
        </div>
      </div>
    </div>
  
    <div *ngIf="clientePerfil.celular" class="card-dados-perfil">
      <div class="card-dados-perfil-content">
        <mat-form-field class="w-100  disabled-view" appearance="outline">
          <mat-label>Celular</mat-label>
          <input
            type="text"
            [disabled]="true"
            matInput
            [value]="clientePerfil.celular | mascara: '(00) 00000-0000'"
            placeholder="Celular">
        </mat-form-field>
        <div class="action">
          <button  mat-flat-button color="primary" class="text-button" (click)="goToSelectValidationTypePage(TipoAlteracaoPerfilEnum.TELEFONE)" color="primary">
            Alterar celular
          </button>
          <button mat-flat-button color="primary" class="icon-button" (click)="goToSelectValidationTypePage(TipoAlteracaoPerfilEnum.TELEFONE)" color="primary">
            <mat-icon>edit</mat-icon>
          </button>
        </div>
      </div>
    </div>
  
    <div *ngIf="!clientePerfil.celular" class="no-email">
      <p>
        O <strong>celular</strong> será usado para você acessar sua conta.
      </p>
      <div class="link-container">
        <mat-icon class="material-symbols-outlined">smartphone</mat-icon>
        <a class="link" href="javascript:void" (click)="showAtualizarPerfilModal(TipoValidacaoCadastral.PHONE)">Adicionar celular</a>
      </div>
    </div>
  
    <div *ngIf="!clientePerfil.email"  class="no-email">
      <p>
        O <strong>e-mail</strong> será usado para recuperar sua conta.
        Caso, por exemplo, você esqueça sua senha.
      </p>
      <div class="link-container">
        <mat-icon class="material-symbols-outlined">email</mat-icon>
        <a class="link" href="javascript:void" (click)="showAtualizarPerfilModal(TipoValidacaoCadastral.EMAIL)">Adicionar e-mail</a>
      </div>
    </div>
  </div>
</div>  
